module.exports = __webpack_public_path__ + "static/media/userpic.980e9288.svg";